import React from 'react';
import Icon from 'components/Icon';
import BaseComponent from 'components/BaseComponent';
import { Modal } from 'antd';
import { getShowPreviewObj } from '@/routes/Material/Util/components/materialUtil';

/** 在线预览网页组件 */
export class WebUrlPreview extends BaseComponent {
    state = {
        checkObj: this.props.checkObj,
    }

    componentWillReceiveProps(nextProps) {
        let { visible, checkObj } = nextProps;
        if (visible) {
            this.setState({
                checkObj
            });
        }
    }

    /** 
     * 查看下一张或者前一张
     * 0:前一张 1: 下一张
     */
    onNextPreMaterial = (nextPre) => {
        let { previewRows } = this.props;
        let checkObj = this.state.checkObj;
        let showPreviewObj = getShowPreviewObj(nextPre, previewRows, checkObj);
        if (!showPreviewObj || !showPreviewObj.id) {
            return;
        }
        this.setState({
            checkObj: showPreviewObj,
        });
    }

    render() {
        const { title, visible, previewRows, hidePreviewHandler } = this.props;
        const { checkObj } = this.state;
        if (!checkObj || !checkObj.id) {
            return null;
        }
        let src = checkObj.url || checkObj.sourcepath;
        if (!src) {
            return null;
        }
        let isNextPre = true;
        if (!previewRows || previewRows.length <= 1) {
            isNextPre = false;
        } 
        let newTitle = title;
        if (checkObj.name) {
            newTitle = title + " - " + checkObj.name;
        }
        return (
            <Modal
                title={newTitle}
                visible={visible}
                width={930}
                maskClosable={false}
                onCancel={hidePreviewHandler}
                footer={null}
                className="original-preview-model"
            >
            {isNextPre ? (
                <div className="original-left">
                    <Icon className="left-arrow-o" onClick={(e) => { this.onNextPreMaterial(0) }} />
                </div>
            ) : null }
            {isNextPre ? (
                <div className="original-right">
                    <Icon className="right-arrow-o" onClick={(e) => { this.onNextPreMaterial(1) }} />
                </div>
            ) : null }
            <div className="original-preview">
                <div className="original-preview-body">
                    <div style={{ width:'100%', height:'100%' }} > 
                        <iframe src={src} style={{ width:'100%', height:'100%' }} />
                    </div>
                </div>
            </div>
        </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/webUrlPreview.js